import { Link } from "react-router-dom";

const socialLinks = [
  { icon: "ri-weibo-line", label: "微博" },
  { icon: "ri-wechat-line", label: "微信" },
  { icon: "ri-instagram-line", label: "Instagram" },
  { icon: "ri-youtube-line", label: "YouTube" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 md:mt-20 bg-primary-950 text-background-100">
      <div className="container-content py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-9 md:gap-10">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-primary-950 flex items-center justify-center font-label font-extrabold text-xs">
                WM
              </span>
              <span className="text-lg font-heading font-bold text-background-50">吴梦梦影视官网</span>
            </div>
            <p className="mt-4 text-sm text-background-200/85 leading-relaxed">
              专注整理吴梦梦的电影、电视剧作品与最新动态，为影迷提供完整、可靠的影视信息入口。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href="#"
                  onClick={(event) => event.preventDefault()}
                  aria-label={`${social.label}（演示链接）`}
                  title={`${social.label}（演示链接）`}
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-background-50/20 text-background-100 hover:bg-background-50/10 hover:border-background-50/40 transition-colors"
                >
                  <i className={`${social.icon} text-base leading-none`} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-xs font-label tracking-[0.2em] text-background-300 uppercase">浏览</h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm">
              {[
                { label: "首页", to: "/" },
                { label: "全部作品", to: "/works" },
                { label: "影视资讯", to: "/news" },
                { label: "关于吴梦梦", to: "/about" },
              ].map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-background-200/85 hover:text-accent-300 transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-label tracking-[0.2em] text-background-300 uppercase">联系</h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-background-200/85">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base leading-none text-accent-300" />
                contact@wumengmeng.film
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-base leading-none text-accent-300" />
                合作与媒体联络
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-base leading-none text-accent-300" />
                工作日 10:00 - 18:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-300/80">© 2026 吴梦梦影视官网 · 保留所有权利</p>
          <p className="text-xs text-background-300/80">
            本站作品、资讯与人物信息均为演示示例内容，不涉及真实用户数据
          </p>
        </div>
      </div>
    </footer>
  );
}